import { useEffect } from "react";
import { useGetAllConfigurationsQuery } from "shared/api";

const setFaviconLink = (id: string, href: string, media?: string) => {
  let link = document.getElementById(id) as HTMLLinkElement | null;

  if (!link) {
    link = document.createElement("link");
    link.id = id;
    link.rel = "icon";
    link.type = "image/png";
    if (media) link.media = media;
    document.head.appendChild(link);
  }

  link.href = href;
};

const removeFaviconLink = (id: string) => {
  const link = document.getElementById(id);
  if (link) link.remove();
};

export const useFavicon = () => {
  const { data: configurations } = useGetAllConfigurationsQuery({});

  const lightSrc = configurations?.find((c) => c.key === "favicon-light")?.file;
  const darkSrc = configurations?.find((c) => c.key === "favicon-dark")?.file;

  useEffect(() => {
    if (!lightSrc && !darkSrc) return;

    document
      .querySelectorAll(
        'link[rel="icon"]:not(#favicon-light):not(#favicon-dark)'
      )
      .forEach((el) => el.remove());

    if (lightSrc && darkSrc) {
      setFaviconLink(
        "favicon-light",
        lightSrc,
        "(prefers-color-scheme: light)"
      );
      setFaviconLink("favicon-dark", darkSrc, "(prefers-color-scheme: dark)");
    } else if (lightSrc) {
      removeFaviconLink("favicon-dark");
      setFaviconLink("favicon-light", lightSrc);
    } else if (darkSrc) {
      removeFaviconLink("favicon-light");
      setFaviconLink("favicon-dark", darkSrc);
    }
  }, [lightSrc, darkSrc]);
};
